import React, {Component} from 'react';
import {FormattedMessage} from "react-intl";
import LocaleLink from "../../Routes/LocaleLink";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowRight} from "@fortawesome/pro-light-svg-icons";

class DigitalJobsInterestSection extends Component
{
    render() {
        return (this.renderDigitalJobs())
    }

    renderDigitalJobs() {
        const jobs = this.props?.linked_digital_jobs ?? null
        if (!jobs) {
            return <></>
        }

        return (
            <section className="section-card-list digital-job-card-list">
                <div className="container">
                    <h2>
                        <FormattedMessage
                            id="portfolio.job_detail.digital_jobs"
                            defaultMessage="Les métiers qui peuvent vous intéresser"
                        />
                    </h2>
                    <ul className="card-list">
                        {jobs.map((job) => {
                            return this.renderDigitalJob(job)
                        })}
                    </ul>
                </div>
            </section>
        )
    }

    renderDigitalJob(job) {
        let color = job.business_unit === 'tech' ? 'text-card-primary' :
            job.business_unit === 'marketing' || job.business_unit === 'sales' ? 'card-regular' : 'text-card-warning';

        return (
            <li className="digital-job-card" key={job.id}>
                <LocaleLink to={`/metiers-digital/${job.business_unit}/${job.slug}`}>
                    <div className={`card ${color}`}>
                        <div>
                            <h2>
                                {job.title}
                            </h2>
                            <p className="digital-job-card-paragraph">
                                {job.description}
                            </p>
                            <FontAwesomeIcon icon={faArrowRight}/>&nbsp;
                        </div>
                    </div>
                </LocaleLink>
            </li>
        )
    }
}

export default DigitalJobsInterestSection;
